// Responses of one form (R-F2): the shared table over «Ответы форм», newest first; a row opens the response with the record it created.

import { useMemo, useState } from 'react';
import type { FormDef, Id, ViewColumn } from '@confdeck/core-shared';
import { navigate, wantsNewTab } from '../shell/router.ts';
import { useMeta, useQuery, useTypesTick } from '../sync/react.tsx';
import { DataTable } from '../table/DataTable.tsx';
import s from './forms.module.css';
import b from '../ui/builder.module.css';

const COLUMNS = ['title', 'status', 'email', 'result', 'error', 'createdAt'];

export function FormResponses({ form }: { form: FormDef }) {
  const meta = useMeta();
  const type = meta.typeByKey('form_response');
  useTypesTick(type ? [type.id] : []);
  const filter = useMemo(() => ({ field: 'form', op: 'eq' as const, value: form.id }), [form.id]);
  const [sort, setSort] = useState([{ field: 'createdAt', dir: 'desc' as 'asc' | 'desc' }]);
  const [columns, setColumns] = useState<ViewColumn[]>(COLUMNS.map((f) => ({ field: f, width: f === 'title' ? 300 : f === 'result' || f === 'error' ? 260 : 160 })));
  const [selected, setSelected] = useState<Set<Id>>(new Set());
  const q = useQuery(type?.id ?? '', filter, sort, '');
  if (!type) return <div className={b.empty}>Ответы недоступны</div>;
  return (
    <div className={s.responses}>
      <div className={s.respHead}>{q.ids.length ? `Ответов: ${q.ids.length}` : 'Ответов пока нет'}</div>
      {q.ids.length > 0 && (
        <DataTable typeId={type.id} ids={q.ids} columns={columns} onColumns={setColumns} sortState={sort}
          onSort={(field, dir) => setSort(dir ? [{ field, dir }] : [])}
          onOpen={(id, e) => (wantsNewTab(e as React.MouseEvent) ? window.open(`/r/${id}`, '_blank') : navigate(`/r/${id}`))} openId={null} selected={selected} onSelect={setSelected} lite />
      )}
    </div>
  );
}
